import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';

type ReceiveTransferOrderFooterProps = {
  onSave: () => void;
  onClose: () => void;
  disabled: boolean;
};

export const ReceiveTransferOrderFooter = ({ onSave, onClose, disabled }: ReceiveTransferOrderFooterProps) => {
  return (
    <FlexRow gap={Gap.Space12}>
      <Button onClick={onClose} theme={THEME_CONSTANTS.secondary}>
        <FormattedMessage {...messages.cancel} />
      </Button>
      <Button disabled={disabled} onClick={onSave} theme={THEME_CONSTANTS.primary}>
        <FormattedMessage {...messages.save} />
      </Button>
    </FlexRow>
  );
};
